// extracted by mini-css-extract-plugin
module.exports = {"bfhs":"bfhs-block_bfhs_V01EK"};